import { IScaffoldActionColLeaveComplete, ScaffoldState } from "./interface";

/**
 * Handles the COL_LEAVE_COMPLETE action by removing the specified column from
 * the leavingCols list once its exit animation has finished.
 *
 * @param action - The COL_LEAVE_COMPLETE action carrying the id of the column that finished animating out.
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with the completed leaving column removed from leavingCols.
 */
export const scr_colLeaveComplete = <T>(
  action: IScaffoldActionColLeaveComplete,
  state: ScaffoldState<T>,
): ScaffoldState<T> => ({
  ...state,
  leavingCols: state.leavingCols.filter((c) => c.id !== action.colId),
});
